import { ReactNode } from 'react';

export function Card({ children }: { children: ReactNode }) {
  return (
    <div className="bg-neutrals-N200 rounded-lg p-4 flex gap-2 justify-between">
      {children}
    </div>
  );
}
